module.exports = __webpack_public_path__ + "static/media/EFR.c4657afa.png";